<script setup lang="ts">
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { UserNotification } from '@/enitites/user'
import { useRouter } from 'vue-router/composables'

const props = defineProps<{
  notification: UserNotification
  readUserNotification: (notification: UserNotification) => void
}>()

const router = useRouter()

const handleProvideFeedback = () => {
  if (router.currentRoute?.name !== `Event` || router.currentRoute.query.tab !== 'feedback') {
    router.push({
      name: 'Event',
      params: { id: `${props.notification.eventId}` },
      query: { tab: 'feedback' },
    })
  }
  props.readUserNotification(props.notification)
}
</script>

<template>
  <div v-if="notification.eventId">
    <button
      class="notification-action"
      @click="handleProvideFeedback"
    >
      Leave a like and provide feedback
      <BKSvgIcon
        class="arrow-icon"
        color="#ff2d53"
        height="24px"
        name="arrow-with-stem"
        width="24px"
      />
    </button>
  </div>
</template>
